<template>
	<div class="content-wrapper">
		<div class="content-header">Akses Snap Portal</div>
		<div class="content-body">
			<div class="snap-card">
				<div class="snap-card-icon">
					<i class="pi pi-check-circle"></i>
				</div>
				<div class="snap-card-content">
					<h3 class="snap-card-title">Akun Snap Anda Sudah Terdaftar</h3>
					<p class="snap-card-desc">
						Email <strong>{{ email }}</strong> sudah terhubung dengan sistem Snap.
						Anda dapat langsung masuk ke Snap Portal untuk mengelola transaksi.
					</p>
					<p v-if="registeredAt" class="snap-card-date">
						Terdaftar sejak {{ formattedDate }}
					</p>
				</div>
				<Button
					label="Masuk ke Snap"
					icon="pi pi-external-link"
					class="snap-enter-btn"
					@click="emit('enter-snap')"
				/>
			</div>
		</div>
	</div>
</template>

<script setup>
import { computed } from 'vue';

// eslint-disable-next-line no-undef
const props = defineProps({
	email: {
		type: String,
		default: '',
	},
	registeredAt: {
		type: String,
		default: null,
	},
});

// eslint-disable-next-line no-undef
const emit = defineEmits(['enter-snap']);

const formattedDate = computed(() => {
	if (!props.registeredAt) return '';
	const date = new Date(props.registeredAt);
	return date.toLocaleDateString('id-ID', {
		day: 'numeric',
		month: 'long',
		year: 'numeric',
	});
});
</script>

<style scoped>
.snap-card {
	display: flex;
	flex-direction: column;
	align-items: center;
	text-align: center;
	padding: 32px 24px;
	background: linear-gradient(135deg, #f0f7ff 0%, #e8f4fd 100%);
	border: 1px solid #b3d4f0;
	border-radius: 12px;
	gap: 20px;
}

@media (min-width: 768px) {
	.snap-card {
		flex-direction: row;
		text-align: left;
		padding: 28px 32px;
	}
}

.snap-card-icon {
	flex-shrink: 0;
	width: 64px;
	height: 64px;
	border-radius: 50%;
	background: linear-gradient(135deg, #2196f3, #1565c0);
	display: flex;
	align-items: center;
	justify-content: center;
}

.snap-card-icon i {
	font-size: 2rem;
	color: #fff;
}

.snap-card-content {
	flex: 1;
}

.snap-card-title {
	margin: 0 0 8px;
	font-size: 1.15rem;
	font-weight: 600;
	color: #1565c0;
}

.snap-card-desc {
	margin: 0 0 8px;
	color: #444;
	line-height: 1.6;
	font-size: 0.95rem;
}

.snap-card-date {
	margin: 0;
	font-size: 0.85rem;
	color: #777;
}

.snap-enter-btn {
	flex-shrink: 0;
	background: linear-gradient(135deg, #2196f3, #1565c0) !important;
	border: none !important;
	font-weight: 600;
	padding: 0.75rem 1.5rem;
}
</style>
